import { http, type HttpResult } from './client';

export const CONTRACTOR_DOCUMENT_MAX_BYTES = 4 * 1024 * 1024;
export interface ContractorSignedDocument {
  id: string; title: string; signedOn: string | null; fileName: string; contentType: string;
  size: number; uploadedAt: string; uploadedByName: string; archivedAt: string | null;
}
export interface ContractorDocumentList {
  contractorId: string; contractorName: string; revision: number; canManage: boolean; documents: ContractorSignedDocument[];
}
const result = (response: HttpResult<unknown>['response'], error: unknown): ContractorDocumentList => {
  if (error) throw error;
  const body: unknown = response?.data;
  const data = body && typeof body === 'object' && 'data' in body ? body.data : body;
  if (!data || typeof data !== 'object' || !('documents' in data) || !Array.isArray(data.documents)) throw new Error('The document list could not be loaded');
  return data as ContractorDocumentList;
};
export async function fetchContractorDocuments(contractorId?: string) {
  const { response, error } = await http({ method: 'GET', url: 'contractor-documents', isToken: true, params: contractorId ? {contractorId} : {} });
  return result(response, error);
}
export async function uploadContractorDocument(contractorId: string, file: File, title: string, signedOn: string, revision: number) {
  const data = new FormData(); data.append('file', file); data.append('title', title); data.append('signedOn', signedOn); data.append('revision', String(revision));
  const { response, error } = await http({ method: 'POST', url: `contractor-documents/${encodeURIComponent(contractorId)}`, isToken: true, data });
  return result(response, error);
}
export async function archiveContractorDocument(contractorId: string, documentId: string, revision: number) {
  const { response, error } = await http({ method: 'POST', url: `contractor-documents/${encodeURIComponent(contractorId)}/${encodeURIComponent(documentId)}/archive`, isToken: true, data: {revision} });
  return result(response, error);
}
export async function downloadContractorDocument(contractorId: string, documentId: string) {
  const { response, error } = await http<Blob>({ method: 'GET', url: `contractor-documents/${encodeURIComponent(contractorId)}/${encodeURIComponent(documentId)}/file`, isToken: true, file: true });
  if (error) throw error;
  if (!(response?.data instanceof Blob)) throw new Error('The document could not be downloaded');
  return response.data;
}
